import { CircularProgress, Dialog } from "@mui/material";
import React from "react";
import { useGetStudentThoseNotCompleteAssignmentQuery } from "src/services/QuestionBankServices";

type Props = {
  assignmentId: string;
  onClose: () => void;
};

const AssignmentUnCompleteStudents = ({ onClose, assignmentId }: Props) => {
  const { data, isLoading, isFetching } =
    useGetStudentThoseNotCompleteAssignmentQuery({ id: assignmentId });

  return (
    <Dialog open maxWidth="md" fullWidth   PaperProps={{
        sx: {
          width: "100%",
          minWidth: "30%!important",
          minHeight: "40%!important",
          maxHeight: "70%!important",
          maxWidth: "50%!important",
        },
      }} >
      {(isLoading || isFetching) && (
        <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
          <CircularProgress />
        </div>
      )}
      <div className="p-4 flex flex-col gap-3">
        <div className="flex justify-between items-center">
          <div className="text-xl font-medium text-red-700">Not Submitted  By</div>
          <button type="button" className="hover:bg-hover" onClick={onClose}>
            Cancel
          </button>
        </div>
        {data?.data?.[0]?.students?.map((el: any, index: any) => {
          return <div key={index} className="font-medium  capitalize">{index+1}. {el?.name} </div>;
        })}
      </div>
    </Dialog>
  );
};

export default AssignmentUnCompleteStudents;
